import crudActions from '../../crud/actions'

const actions = crudActions('CAREPLAN_MEDICATION_TASKS_')

export default actions
